<template>
  <v-app-bar app clipped-left dark class="bg_navbar" elevation="8" flat height="102">
    <v-app-bar-nav-icon @click="open" tile class="btn-sidebar main_color--text" v-if="windowWidth <= 1200"></v-app-bar-nav-icon>
    <div class="logo-container" v-if="windowWidth >= 1200">
        
        <v-img
          :src="getThemeImage('logo_navigation_postlogin')"
          height="50"
          
          style="margin-left: -40px;"
          contain
          
        />

      </div>
    <v-toolbar-title class="pa-0">
      
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="d-flex align-center ml-auto mr-2 mr-md-12">
      <div class="cart-container mr-2 mr-md-4" v-if="account.loggedIn">
        <v-badge 
          overlap 
          :color="cartStore.numberCartItems > 0 ? '#4CAF50' : 'transparent'"
          :content="cartStore.numberCartItems"
          offset-x="10"
          offset-y="10"
          class="hidden-sm-and-up">
          <router-link :to="{name: 'portfolio', params:{step: 1}}" class="text-decoration-none">
            <v-icon color="white" v-on="on" v-bind="attrs" size="24">
                  mdi-cart-outline
              </v-icon>
          </router-link>
        </v-badge>
        <v-badge 
          overlap 
          :color="cartStore.numberCartItems > 0 ? '#4CAF50' : 'transparent'"
          :content="cartStore.numberCartItems"
          offset-x="8"
          offset-y="8"
          class="hidden-xs-only">
          <router-link :to="{name: 'portfolio', params:{step: 1}}" class="text-decoration-none">
            <v-tooltip bottom>        
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="white" v-on="on" v-bind="attrs" size="28">
                  mdi-cart-outline
                </v-icon>
              </template>
              <span>Mis Pagos</span>
            </v-tooltip>
          </router-link>
        </v-badge>
      </div>

      <v-menu 
        offset-y 
        transition="scale-transition"
        content-class="menu-limpio-custom"
        v-if="account.loggedIn && account.user != null"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="user-pill-btn px-2 px-md-4">
            <div class="avatar-box mr-0 mr-md-3">
              <span>{{ getProfileLetterName() }}</span>
            </div>
            
            <div class="d-flex flex-column align-start hidden-xs-only">
              <span class="welcome-text">BIENVENIDO</span>
              <span class="user-name-text">{{ getProfileName() }}</span>
            </div>
            <v-icon color="white" small class="ml-0 ml-md-4">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-card class="menu_usuario_card elevation-8">
          <div class="menu-header">
            <v-avatar class="mr-4 avatar_custom">
              <v-img v-if="account.user.avatar && account.user.avatar != 'null'"
                    :src="account.user.avatar_path"></v-img>
              <span v-else>{{ getProfileLetterName() }}</span>
            </v-avatar>
            <router-link :to="{name: 'user_profile'}" class="text-decoration-none" v-if="!isGuestCurrentUser()">
              <div class="d-flex flex-column">
                <span class="menu-user-name">{{ getProfileName() }}</span>
                <span class="menu-user-email">{{ account.user.email }}</span>
              </div>
            </router-link>
          </div>

          <v-list dense nav class="options-item">
            <v-list-item link @click="goToHomeFromBuzon">
              <v-list-item-icon>
                <v-icon class="email-icon" color="#12312B">mdi-email-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mi buzón</v-list-item-title>
                <v-list-item-subtitle>5 mensajes nuevos</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{name: 'user_profile'}" v-if="!isGuestCurrentUser()">
              <v-list-item-icon>
                <v-icon class="perfil-icon" color="#707272">mdi-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar perfil</v-list-item-title>
                <v-list-item-subtitle>Actualiza tu información</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{name: 'password_update'}" v-if="!isGuestCurrentUser()">
              <v-list-item-icon>
                <v-icon class="psswd-icon" color="#B38E5D">mdi-lock-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Cambiar contraseña</v-list-item-title>
                <v-list-item-subtitle>Seguridad de cuenta</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-list dense nav class="menu-footer">
            <v-list-item link @click="doLogout">
              <v-list-item-icon>
                <v-icon class="logout-icon" color="#7a0c2e">mdi-logout</v-icon>
              </v-list-item-icon>
                <v-list-item-title class="logout-text">Cerrar sesion</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex';
import router from '../config/router';
import {procedureListRequest} from '../api/models';
import * as Storage from '@/core/storage.js';


export default {
  props: ['pDrawer'],
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      envLogo: process.env.VUE_APP_LOGO,
      title: '',
      FILTER_STATUS_ALL: 0
    };
  },
  computed: {
    ...mapState(
        {
          account: state => state.account,
          appBar: state => state.appBar,
          cartStore: state => state.cart,
          proceduresStore: state => state.procedures
        }),

    getThemeImage() {
      return (key) => {
        const themeIcons = this.$vuetify.theme.themes.light?.icons;
        if (!themeIcons || !themeIcons[key]) {
          console.warn(` La clave "${key}" no existe en los iconos del tema.`);
          return '';
        }

        const path = themeIcons[key];

        try {
          return require(`@/assets/${path}`);
        } catch (error) {
          console.error(`⚠️ Error al cargar la imagen: ${path}`, error);
          return '';
        }
      };
    },
  },

  mounted() {
    // console.log("Usuario logueado: ", this.account.user)
    // if (this.account.loggedIn)(
    //     this.getNumberOfItems()
    // )

    this.getCurrentPage();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      if (this.account.loggedIn && this.cartStore.numberCartItems === 0) (
          this.getNumberOfItems()
      );

      this.getCurrentPage();
    },
  },

  methods: {
    ...mapActions('account', ['logout']),
    ...mapActions('cart', ['getNumberOfItems']),
    ...mapGetters('account', ['isGuestUser']),
    ...mapActions('procedures', ['getProceduresByUser']),

    open() {
      this.$emit('openCloseDrawer', window.innerWidth);
    },

    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.$emit('onResizeWidth', this.windowWidth);
    },

    doLogout() {
      this.logout();
    },

    getProfileName() {
      try {
        // Usamos la capa Storage (user NO encriptado según tu criterio)
        const user = Storage.getItem('user', {encrypt: false});
        if (!user) return '';

        return `${user.nombres ?? ''} ${user.apellido_paterno ?? ''} ${user.apellido_materno ?? ''}`.trim();
      } catch (e) {
        console.error('❌ Error al obtener el usuario desde localStorage:', e);
        return '';
      }
    },

    getProfileLetterName() {
      try {
        const user = Storage.getItem('user', {encrypt: false});
        if (!user) return 'U';

        return (user.nombres?.trim()?.charAt(0)?.toUpperCase() ?? 'U');
      } catch (e) {
        console.error('❌ Error al obtener inicial:', e);
        return 'U';
      }
    },

    // resto de métodos igual...
    getCurrentPage() { /* ... */
    },
    isGuestCurrentUser() {
      return this.isGuestUser();
    },
    goToHomeFromBuzon() {
      router.push({name: 'process'});
      let request = procedureListRequest();
      request.userId = this.account.user.id;
      request.status = this.FILTER_STATUS_ALL;
      request.limit = this.proceduresStore.pageLimit;
      this.getProceduresByUser(request);
    }
  }
};
</script>

<style>


.btn-sidebar {
  background: white !important;
  margin-left: 0 !important;
  height: 64px !important;
}

.v-toolbar__content {
  padding: 0 !important;
}

.v-application a {
  text-decoration: none !important;
}

a.router-link-active {
  text-decoration: none !important;
}

.v-app-bar.v-app-bar--fixed {
  z-index: 10 !important;
}

@media (max-width: 899px) {
  .btn-sidebar {
    background: white !important;
    margin-left: 0 !important;
    height: 58px !important;
  }
}

/* Contenedor del Carrito */
.cart-container {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Botón tipo "Pill" del Usuario */
.user-pill-btn {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 20px !important;
  height: 56px !important;
  text-transform: none !important;
  padding: 0.5rem 1vw !important; /* El padding cambia según el ancho de pantalla */
  min-width: 50px !important; /* Mínimo para que no desaparezca */
  max-width: 100% !important;
}

/* El cuadro del avatar */
.avatar-box {

  background:linear-gradient(#2f5349, #1A302B);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif;
}


.welcome-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 1px;
  line-height: 1;
}

.user-name-text {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: white;
  line-height: 1.2;
  font-size: clamp(0.7rem, 2vw, 0.9rem) !important;
}


.v-badge__badge {
  font-family: 'Montserrat', sans-serif !important;
  font-weight: bold !important;
  font-size: 10px !important;
}

.logo-container {
    display: flex;
    align-items: center;
    /* En lugar de mover el logo con margen negativo, 
       ajustamos el contenedor para que empiece desde el borde */
    padding-left: 10px; 
    min-width: 200px; /* Asegura que el espacio esté reservado desde el inicio */
}


/*Estilo para el menú*/

.menu_usuario_card {
  width: 90vw !important;
  max-width: 256px !important;
  height: auto !important;
  min-height: 356px !important;
  border: 1px solid #621132 !important;
  border-radius: 20px !important;
  overflow: hidden !important;
}

.menu-header {
  display: flex !important;
  align-items: center !important;
  padding: 20px !important;
  background: #f4f4f4 !important;
}

.menu-footer {
  display: flex !important;
  align-items: center !important;
  padding: 20px !important;
  background: #f4f4f4 !important;
}

.menu-user-name {
  font-weight: 600 !important;
  font-size: 16px !important;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-user-email {
  font-size: 13px !important;
  color: #6B7280 !important;
}

.email-icon{
  width: 36px;
  height: 36px;
  background-color: #265B4E33;
  border-radius: 10px !important;
}

.perfil-icon{
  width: 36px;
  height: 36px;
  background-color: #98989A33;
  border-radius: 10px !important;
}

.psswd-icon{
  width: 36px;
  height: 36px;
  background-color: #D4C19C33;
  border-radius: 10px !important;
}

.logout-icon {
  width: 50px;
  height: 36px;
  background-color: #9D244933;
  border-radius: 10px !important;
}


.options-item{
  padding: 16px !important;
}

.logout-text {
  color: #7A0C2E !important;
  font-weight: 500 !important;
}

.avatar_custom {
  width: 48px;
  height: 48px;
  background-color: #6d0f2f;
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 600;
  font-size: 18px;

  border-radius: 16px;
  cursor: pointer;

  transition: all 0.2s ease;
}

/* Usamos un selector súper específico para ganar la batalla de prioridad */
.v-menu__content.menu-limpio-custom {
  box-shadow: none !important;
  margin-top: 30px;
}

.menu-limpio-custom .v-sheet {
  box-shadow: none !important;
}
</style>

